// ─────────────────────────────────────────────────────────────
//  TAP REVIEW · SITE CONFIGURATION
//  Everything you need to edit for launch lives in this one file.
// ─────────────────────────────────────────────────────────────

// ─────────────────────────────────────────────────────────────
//  STRIPE CHECKOUT
//  V1 uses a single Stripe Payment Link (no backend, no secret keys).
//
//  Before launch, in your Stripe Dashboard → Payment Links, configure ONE
//  link for the £29.99 Tap Review NFC Stand (+ £4.99 shipping) and enable:
//    1) A REQUIRED custom text field labelled "Business Google Review URL"
//       (so every customer provides their Google review link at checkout).
//    2) "Let customers adjust quantity" (so quantity is handled by Stripe —
//       the purchased quantity always matches what the customer selects).
//  Then paste that link below.  ⬇️
export const SITE = {
  brand: "TAP REVIEW",
  price: "£29.99",

  // ⬇️ Live Stripe Payment Link.
  STRIPE_PAYMENT_LINK: "https://buy.stripe.com/eVqdRaaPYdxL610cmHfUQ00",

  // ⬇️ REPLACE with your real business contact details.
  contactEmail: "hello@tapreview.com",
  companyName: "Tap Review",
};

// ─────────────────────────────────────────────────────────────
//  PRODUCT IMAGES  (real photography — replace paths to swap)
//  Files live in /app/frontend/public/products/
// ─────────────────────────────────────────────────────────────
export const PRODUCT_IMAGES = {
  hero: "/products/img51.jpeg",       // black glossy countertop stand on a counter
  purchase: "/products/img51.jpeg",   // product showcase in the purchase card
  demo: "/products/img52.jpeg",       // "in action" — tap-to-review moment
};
